var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"messages-list-table"},_vm._l((_vm.group.Messages),function(message){return (!message.IsDeleted)?_c('div',{key:message.MessageId,staticClass:"message-container"},[_c('message',{attrs:{"message":message}})],1):_vm._e()}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5218ec9e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Messenger/MessageList/MessageList.vue
// module id = lhAK
// module chunks = 1